import ReactDom from "react-dom";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from './serviceWorker';
import DynamicComponentLoader from './components/DynamicComponentLoader.js'

import './css/index.css'

ReactDom.render((
  <BrowserRouter>
    <div className="app">
      <DynamicComponentLoader /> 
    </div>
  </BrowserRouter>
), document.getElementById("app"));

serviceWorker.register();
